import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>
          Coming Soon!
          {/* Očekujte uskoro! */}
        </p>
        <p>
          <img src={logo} className="App-logo" alt="logo" />
        </p>
        <a
          className="App-link"
          href="https://xardllc.netlify.app/"
          // target="_blank"
          target="_self"
          rel="noopener noreferrer"
        >
          ©2021 Xard LLC
        </a>
      </header>
    </div>
  );
}

export default App;
